export const environment = {
  production: false,
  apiBaseURL: 'https://staging-api.emma.knustconnect.de'
};
